
import { VisitActive, VisitPassive } from "../../../../assets/icons";

export default function FieldAvatarDelete({ avatarDelete, onChange }) {
	return (
		<div className="flex flex-row items-center justify-between gap-3 rounded-xl border border-[#E2E8F0] px-4 py-3">
			<div className="font-Vazir-500 text-[14px] text-midGray">حذف آواتار</div>
			<button
				type="button"
				className={[
					"min-w-[120px] rounded-[10px] p-[10px] cursor-pointer border-0",
					avatarDelete ? "bg-[#CDE7FF]" : "bg-[#EBEFF3]",
				].join(" ")}
				onClick={() => onChange(!avatarDelete)}
				aria-pressed={avatarDelete}
			>
				{avatarDelete ? (
					<div className="flex flex-row justify-between items-center bg-white h-[20px] rounded-[10px] px-[10px] py-[5px]">
						<div className="flex flex-row justify-center items-center w-[25px] h-[25px] rounded-[20px] bg-[#276AA6]">
							<VisitActive />
						</div>
						<div className="spacer p-[5px]"></div>
						<div className="font-Vazir-400 text-[12px] text-[#aaaaaa]">فعال</div>
					</div>
				) : (
					<div className="flex flex-row justify-between items-center bg-white h-[20px] rounded-[10px] px-[10px] py-[5px]">
						<div className="font-Vazir-400 text-[12px] text-[#aaaaaa]">غیرفعال</div>
						<div className="spacer p-[5px]"></div>
						<div className="flex flex-row justify-center items-center w-[25px] h-[25px] rounded-[20px] bg-[#969BA1]">
							<VisitPassive />
						</div>
					</div>
				)}
			</button>
		</div>
	);
}
